import { render, staticRenderFns } from "./breed.vue?vue&type=template&id=92c31c9e&scoped=true"
import script from "./breed.vue?vue&type=script&lang=js"
export * from "./breed.vue?vue&type=script&lang=js"
import style0 from "./breed.vue?vue&type=style&index=0&id=92c31c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c31c9e",
  null
  
)

export default component.exports